const FIRST_PROMOTER_REFERRAL_EMAIL_KEY = "firstPromoterReferralEmail";

type FirstPromoter = (event: "referral", attributes: { email: string }) => void;

export function stashFirstPromoterReferralEmail(email: string): void {
  localStorage.setItem(FIRST_PROMOTER_REFERRAL_EMAIL_KEY, email);
}

export function consumeFirstPromoterReferralEmail(): null | string {
  const email = localStorage.getItem(FIRST_PROMOTER_REFERRAL_EMAIL_KEY);

  if (email) {
    localStorage.removeItem(FIRST_PROMOTER_REFERRAL_EMAIL_KEY);
  }

  return email;
}

export function trackFirstPromoterReferral(email: string): void {
  if (typeof window.fpr !== "function") {
    return;
  }

  try {
    window.fpr("referral", { email });
  } catch (error) {
    console.error("Failed to track FirstPromoter referral:", error);
  }
}

declare global {
  interface Window {
    fpr?: FirstPromoter;
  }
}
